import React from 'react'

export const Project = () => {
  return (
    <>
      <div class="section">
        <h2>Device Testing Tool – Group Project (Vendia – client)</h2>
        <p><strong>Role:</strong> Project manager</p>
        <p><strong>Front-end:</strong> React.js, JSX, CSS (Bootstrap), MUI-X</p>
        <p><strong>Back-end:</strong> Firebase, Firestore, Vendia API</p>
        <p><strong>Description:</strong> Implemented a user-friendly web interface.</p>
      </div>

      <div class="section">
        <h2>Website Portfolio</h2>
        <p><strong>Front-end:</strong> React.js, JSX, CSS (TailwindCSS)</p>
        <p><strong>Back-end:</strong> EmailJS</p>
      </div>
    </>
  )
}